
import { Observable } from 'rxjs'
import { QuillFormat } from './config/public_api'

export const getFormat = (format?: QuillFormat, configFormat?: QuillFormat): QuillFormat => {
  const passedFormat = format || configFormat
  return passedFormat || 'html'
}

export const raf$ = () => {
  return new Observable(subscriber => {
    const rafId = requestAnimationFrame(() => {
      subscriber.next()
      subscriber.complete()
    })

    return () => cancelAnimationFrame(rafId)
  })
}
